import { render } from "./PrizeItem.vue?vue&type=template&id=37aba41e"
import script from "./PrizeItem.vue?vue&type=script&lang=js"
export * from "./PrizeItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__